import TimePicker from './range-picker';

export default TimePicker;
